import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv, SummaryDiv } from '../TextStyle'
import { imgItems, imgLinks } from './ImageItems'
import { LinkText } from '@/components/elements/LinkText'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Index } from '@/components/layouts/Legal/Index'

const sectionTitle = {
  titleText: 'Image Policy',
  subTitleText: '画像規約',
}

const tSummary = (
  <p>
    この画像規約（以下、「本規約」といいます）は、トライアルグループ（株式会社トライアルホールディングス及びそのグループ会社※をいいます）が、メディア向け資料として公開している画像（以下、「本画像」といいます）の取り扱いについて定めた規約です。
    <br />
    本画像をダウンロードされた時点で、本画像をダウンロードした者（以下、「利用者」といいます）は本規約に同意したものとみなします。
    <br />
    ※株式会社トライアルホールディングスのグループ会社は
    <LinkText path="/company/overview/" text="こちら" />
    です。
  </p>
)
export const ImagePolicyPage = () => {
  return (
    <>
      <Head
        title="画像規約"
        description="トライアルホールディングスの画像規約を掲載しています。"
        ogp={{ type: 'article', url: 'legal/image-terms/' }}
      />
      <ImageContainer>
        <CompleteTitle>
            <SectionTitle
              color="normal"
              titleText={sectionTitle.titleText}
              subTitleText={sectionTitle.subTitleText}
            />
          </CompleteTitle>
        <Spacer h={{ pc: 70, sp: 60 }} />
        <SummaryDiv>{tSummary}</SummaryDiv>
        <Spacer h={{ pc: 70, sp: 35 }} />
        <Index columnGap={46} listType="article" links={imgLinks} />
        <Spacer h={{ pc: 70, sp: 40 }} />
        {imgItems.map(({ children, id }, index) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < imgItems.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </ImageContainer>
    </>
  )
}
ImagePolicyPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '法務',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '法務', path: '/legal/' },
    { name: '画像規約', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const ImageContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 68px;
  }
`

const CompleteTitle = styled.div`
  width: 100%;
  margin: 0 auto;
  @media screen and (max-width: 1047px) {
    max-width: 200px;
  }
`
